<template>
  <div class="prizes_carousel">
    <div  class="swiper swiper_prizes_carousel">
      <div class="swiper-wrapper owl-carousel h-carousel" style="z-index:0">
        <div class="swiper-slide" v-for="prize in getCarouselPrizes" :key="prize.type">
          <div class="carousel_prize_container" style=" height: auto!important">
            <img :src="prize.imgUrl"  alt="" class="">
            <h1 v-if="prize.type === 'GRAND' && getTranslations.home_carousel_grand">{{ getTranslations.home_carousel_grand }}</h1>
            <h1 v-else-if="prize.type === 'MONTHLY' && getTranslations.home_carousel_month">{{ getTranslations.home_carousel_month }}</h1>
            <h1 v-else-if="prize.type === 'DAILY' && getTranslations.home_carousel_day">{{ getTranslations.home_carousel_day }}</h1>
            <h1 v-else-if="prize.type === 'WEEKLY' && getTranslations.home_carousel_week">{{ getTranslations.home_carousel_week }}</h1>
            <h1 v-else>{{ prize.type }}</h1>
            <p>{{ prize.headline }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import 'owl.carousel';

export default {
  name: 'carousel',
  methods: {
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
    ]),
  },
  mounted() {
    this.storeAvailablePrizeTypes(this.getLocale).then(() => {
      this.$nextTick(() => {
        /*eslint-disable */
        $('.h-carousel').owlCarousel({
          dots: this.getCarouselPrizes.length > 1 ? true : false,
          autoplay: this.getCarouselPrizes.length > 1 ? true : false,
          autoplayTimeout: 5000,
          center:  this.getCarouselPrizes.length == 1 ? true: false,
          autoplayHoverPause: this.getCarouselPrizes.length > 1 ? true : false,
          navText: '',
          responsive: {
            0: {
              items: this.getCarouselPrizes.length >= 3 ? 3 : this.getCarouselPrizes.length ,
              nav: true,
            },
          },
        });
      });
    });

  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Carousel.vue